import { Base64 } from '@/utils/base64';
import store from '@/store';

export function filePreview({ fileUrl, fileName, fileExtention }) {
  window.open(
    `https://fileview.spdspd.com/onlinePreview?url=${encodeURIComponent(
      Base64.encode(
        `${'https://spdcore.test.spdio.com'
        + '/'}${fileUrl
        }?authorization=Bearer%20${store.state.sessionId
        }&fullfilename=${fileName}`,
      ),
    )}&watermarkTxt=${store.state.user?.userName}`,
  );
}
